export function mapOpportunityBuyers(opportunity = {}) {
  const commercialBuyer = opportunity.commercial_buyer_name || opportunity.commercial_buyer || null;
  const technicalBuyer = opportunity.technical_buyer_name || opportunity.technical_buyer || null;

  return {
    commercialBuyer,
    technicalBuyer,
    commercialBuyerId: opportunity.commercial_buyer_id || null,
    technicalBuyerId: opportunity.technical_buyer_id || null,
    commercialBuyerCoach: !!opportunity.is_comm_buyer_coach,
    technicalBuyerCoach: !!opportunity.is_tech_buyer_coach,
  };
}
